export default __webpack_public_path__ + "static/media/iPAMS_Banner-Image-1536x418.0d8174ab.jpg";